import React, { useCallback, useRef, useState } from 'react';
import { Badge, Button, Card, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { BsCopy } from 'react-icons/bs';
import { pretestApi } from '../../../../shared/pretests/pretestApi';
import { pretestError } from '../../../../shared/pretests/pretestModel';
import { PretestError, PretestLoading } from '../../../../shared/pretests/PretestUI';
import usePretestPage from '../../../../shared/pretests/usePretestPage';
import './ExampleManage.css';

function ShareTestLink({ testId }) {
  const url = `https://www.chicchiclawtutor.com/pre-tests/${encodeURIComponent(testId)}`;
  const link = useRef(null);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  async function copy() {
    if (busy) return;
    setBusy(true); setMessage('');
    let copied = false;
    try {
      if (navigator.clipboard?.writeText) { await navigator.clipboard.writeText(url); copied = true; }
    } catch { /* Try the legacy copy command when clipboard access is denied. */ }
    if (!copied) {
      const input = document.createElement('textarea');
      const previousFocus = document.activeElement;
      input.value = url; input.readOnly = true;
      Object.assign(input.style, { position: 'fixed', top: '0', left: '0', opacity: '0' });
      document.body.appendChild(input);
      try {
        input.focus({ preventScroll: true }); input.select(); input.setSelectionRange(0, url.length);
        copied = document.execCommand?.('copy') === true;
      } catch { /* Keep the visible URL available for manual copying. */ }
      finally { input.remove(); previousFocus?.focus({ preventScroll: true }); }
    }
    if (!copied && link.current) {
      link.current.focus({ preventScroll: true });
      const selection = window.getSelection();
      const range = document.createRange(); range.selectNodeContents(link.current);
      selection?.removeAllRanges(); selection?.addRange(range);
    }
    setMessage(copied ? 'คัดลอกลิงก์แล้ว' : 'คัดลอกอัตโนมัติไม่สำเร็จ กรุณาคัดลอกลิงก์ด้านบนด้วยตนเอง');
    setBusy(false);
  }
  return <div className="mb-3">
    <p className="small mb-1">ลิงก์สำหรับแชร์</p>
    <div className="pretest-share-url">
      <a ref={link} className="pretest-share-url__link" href={url} target="_blank" rel="noopener noreferrer">{url}</a>
      <Button size="sm" variant="outline-secondary" disabled={busy} onClick={copy}><BsCopy aria-hidden="true" className="me-1"/>คัดลอก</Button>
    </div>
    <div role="status" className="small mt-1">{message}</div>
  </div>;
}
export default function ExampleManage() {
  const [status, setStatus] = useState('all');
  return <div className="pretest-page"><h1 className="h4">จัดการแบบทดสอบ Pre-test</h1><Button as={Link} to="/account/admin/pre-tests/new" className="mb-3">สร้างแบบทดสอบ</Button>
    <Form.Group controlId="pretest-status" className="mb-3"><Form.Label>สถานะ</Form.Label><Form.Select value={status} onChange={e => setStatus(e.target.value)}><option value="all">ทั้งหมด</option><option value="active">เปิดใช้งาน</option><option value="hidden">ปิดใช้งาน</option></Form.Select></Form.Group><AdminList key={status} status={status}/></div>;
}
function AdminList({ status }) {
  const load = useCallback(cursor => pretestApi.list({ admin: true, status, cursor }), [status]); const page = usePretestPage(load);
  const [busy, setBusy] = useState(''); const [error, setError] = useState('');
  async function toggle(test) { if (busy) return; setBusy(test.id); setError(''); try { await pretestApi.setActive(test, !test.isActive); page.retry(); } catch (e) { setError(pretestError(e)); } finally { setBusy(''); } }
  return <>{page.loading && <PretestLoading/>}<PretestError error={error || page.error} retry={page.retry} busy={!!busy}/>
    {!page.loading && !page.error && !page.items.length && <p>ยังไม่มีแบบทดสอบในรายการนี้</p>}
    {page.items.map(t => <Card className="mb-3" key={t.id}><Card.Body><h2 className="h5">{t.content.title} <Badge bg={t.isActive ? 'success' : 'secondary'}>{t.isActive ? 'เปิดใช้งาน' : 'ปิดใช้งาน'}</Badge></h2><p>{t.content.questions.length} ข้อ · รุ่น {t.version}</p><ShareTestLink testId={t.id}/><div className="d-flex flex-wrap gap-2"><Button as={Link} to={`/account/admin/pre-tests/${t.id}/edit`}>แก้ไข</Button><Button variant="outline-secondary" disabled={!!busy || page.loading} onClick={() => toggle(t)}>{busy === t.id ? 'กำลังบันทึก...' : t.isActive ? 'ปิดใช้งาน' : 'เปิดใช้งาน'}</Button>{t.isActive && <Button as={Link} to={`/pre-tests/${t.id}`} variant="outline-primary">เปิดแบบทดสอบ</Button>}</div></Card.Body></Card>)}
    <div className="d-flex gap-2"><Button onClick={page.first} disabled={page.loading || !!busy} variant="outline-secondary">โหลดหน้าแรก</Button>{page.next && <Button onClick={page.more} disabled={page.loading || !!busy}>หน้าถัดไป</Button>}</div></>;
}
